import { RouteObject } from 'react-router-dom';
import QuizletVariantRedirect from '@/app/components/quizletv2/quizlet-variant-redirect';

export const routeQuizletVariant: RouteObject = {
  path: '/quizlet',
  element: <QuizletVariantRedirect />,
};
